module.exports = __webpack_public_path__ + "static/media/delta.22990701.jpg";